export function location(endpoint){
  const newUrl = document.createElement('a');
  //  Set href to any path
  newUrl.setAttribute('href', window.location.href);
  let url = window.location.href
  // if(window.location.href == 'http://localhost:8080/' || window.location.href == 'http://localhost:3011'){
  //   url = 'http://localhost:3011/'
  // }
  if(newUrl.hostname == 'localhost'){
    if(endpoint != undefined){
      url = 'http://localhost:3030/' + endpoint;
    }else{
      url = 'http://localhost:3030/';
    }
  }else{
    if(endpoint != undefined){
      url = newUrl.protocol + "//" + newUrl.hostname + "/" + endpoint;
    }else{
      url = newUrl.protocol + "//" + newUrl.hostname + "/";
    }
  }
  // console.log(url)
  return url
}